export default __webpack_public_path__ + "src/images/btn_refresh-f635d0.png";